module.exports = __webpack_public_path__ + "img/修改.94b05095.svg";